export default {
  getScreen: function() {
    var width = document.body.clientWidth;
    if (width >= 1200) {
      return 3; //大屏幕
    } else if (width >= 992) {
      return 2; //中屏幕
    } else if (width >= 768) {
      return 1; //小屏幕
    } else {
      return 0; //超小屏幕
    }
  }
};

/****
 * 过滤特殊字符串$
 */
export function filtration$(row) {
  row = JSON.stringify(row, function(k, v) {
    return k.startsWith("$") || k.startsWith("addDisabled") ? undefined : v;
  });
  return JSON.parse(row);
}

/****
 * 将字典接口的数据转换成树接口的数据
 */
export function dicToTree(list) {
  return list.map(item => {
    return {
      id: item.value,
      parentId: 0,
      title: item.label,
      value: item.value,
      key: item.value,
      hasChildren: false
    };
  });
}

/****
 * 给空数组一个默认值
 */
export function emptyArray(list) {
  return list != null && list.length > 0 ? list : [{}];
}

/****
 * 将数组转换成逗号拼接的字符串
 */
export function filtrationAraay(row) {
  Object.keys(row).forEach(function(key) {
    if (row[key] instanceof Array) {
      row[key] = row[key].join(",");
    }
  });
  return row;
}
